import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { QueryState } from 'src/app/core/models/query.model';
import { Notifications } from './notification.model';



export const NOTIFICATION_ENDPOINT = 'notifications'
export const NOTIFICATION_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(NOTIFICATION_ENDPOINT);


export const notificationStateConfig: SignalStoreConfig<QueryState<Notification>> = {
  initState: {
    list: []
  }
}


export const notificationDropdownStateConfig = {
  initState: {
    notifications: [],
  }
}


